import { forwardRef } from "react";

import { FormField, useFormContext } from "@ui/components/Form";
import { Select } from "@ui/components/Inputs/Select";
import { TextInput } from "@ui/components/Inputs/TextInput";
import { useTranslations } from "@ui/providers/useTranslations";

import type { DateInputProps } from "../../BirthDateFormInputs";

import styles from "../../BirthDateFormInputs.module.scss";

export const MONTH_INPUT_MAX_LENGTH = 2 as const;

export const MonthInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ placeholder, ariaLabel, onKeyUp, type }, monthInputRef) => {
    const { __ } = useTranslations();
    const { formState } = useFormContext();
    if (type === "select") {
      return (
        <FormField
          name="month"
          validation={{
            required: true,
          }}
          className={styles.selectInput}
          ref={monthInputRef}
          render={({ field }) => {
            return (
              <Select
                {...field}
                options={Array.from({ length: 12 }, (_, i) => ({
                  value: String(i + 1),
                  label: __(`daypicker.month.${i + 1}`),
                }))}
                placeholder={placeholder}
                aria-label={ariaLabel}
                dataTestId="month-input"
                isError={!!formState.errors.month}
                isSearchable={false}
                menuPosition="fixed"
                required
              />
            );
          }}
        />
      );
    }
    return (
      <FormField
        name="month"
        validation={{
          required: true,
          validate: {
            dateValid: (month) => month >= 1 && month <= 12,
          },
        }}
        render={({ field }) => (
          <TextInput
            {...field}
            placeholder={placeholder}
            aria-label={ariaLabel}
            maxLength={MONTH_INPUT_MAX_LENGTH}
            type="text"
            inputMode="numeric"
            data-testid="month-input"
            ref={monthInputRef}
            onKeyUp={onKeyUp}
            isError={!!formState.errors.month}
          />
        )}
      />
    );
  }
);
